import {
  VerificationLevel,
  VerificationLevels,
  ComplianceEntity
} from "@wingspanhq/wingspan-api-sdk";
import { selectorComplianceEntityCountry } from "../../../shared/selectors/selectorComplianceEntityCountry";

export const selectorIsUsPersonVerificationAvailable = (
  monitoredEntity: ComplianceEntity | undefined,
  verifications: VerificationLevels | undefined
) => {
  const country = selectorComplianceEntityCountry(monitoredEntity);
  const type = monitoredEntity?.type;
  const usVerificationStatus = verifications?.profiles?.["US"]?.tax;

  const isNonUSUser = country ? country !== "US" : false;
  const isIndividual = type === "Individual";
  const isUSUsedNonVerified =
    usVerificationStatus !== VerificationLevel.VERIFIED &&
    usVerificationStatus !== VerificationLevel.PENDING;

  return isNonUSUser && isIndividual && isUSUsedNonVerified;
};
